export default function () {
    return (
        <svg width="434" height="82" viewBox="0 0 434 82" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M267.199 34.5731C271.424 34.5731 275.773 31.151 276.906 26.9174L279.203 18.3354C280.336 14.1094 277.825 10.6797 273.599 10.6797H236.851L234.647 18.9019H270.927L268.936 26.3509H232.648L226.31 50.183H234.317L238.497 34.5731H248.978L260.408 50.183H272.06L260.638 34.5731H267.199Z"
                fill="white"
            />
            <path d="M355.507 10.6797L324.379 50.183H333.436L357.222 19.9967L364.832 50.183H373.896L363.928 10.6797H355.507Z" fill="white" />
            <path
                d="M140.635 26.3279L142.625 18.8866H178.883L181.08 10.6797H144.493C140.267 10.6797 135.919 14.1094 134.786 18.3354L130.445 34.5348H166.702L164.712 41.9838H128.455L126.257 50.183H162.844C167.07 50.183 171.418 46.7533 172.551 42.5273L176.892 26.3279H140.635Z"
                fill="white"
            />
            <path
                d="M424.921 50.183L433.457 18.3354C434.59 14.1094 432.079 10.6797 427.853 10.6797H388.204L377.616 50.183H385.838L394.26 18.6646H405.697L397.276 50.183H405.261L413.682 18.6646H425.12L416.699 50.183H424.921Z"
                fill="white"
            />
            <path d="M184.609 18.8866H202.776L194.393 50.183H202.393L210.784 18.8866H228.951L231.148 10.6797H186.814L184.609 18.8866Z" fill="white" />
            <path d="M276.416 50.1832H320.658L322.847 41.984H286.613L288.611 34.535H324.845L327.05 26.3281H282.808L276.416 50.1832Z" fill="white" />
            <path d="M284.799 18.8866H329.041L331.238 10.6797H287.004L284.799 18.8866Z" fill="white" />
            <path d="M100.343 34.535H122.445L124.642 26.3281H102.548L100.343 34.535Z" fill="white" />
            <path d="M53.9034 0H31.6177L51.0861 26.3355L65.295 15.4032L53.9034 0Z" fill="white" />
            <path d="M76.6181 60.8703H98.9038L81.0431 36.709L65.6704 46.0719L76.6181 60.8703Z" fill="white" />
            <path d="M119.314 0H91.317L42.9101 37.1377H53.5056L0 82L91.6616 26.3279H80.9436L119.314 0Z" fill="url(#paint0_linear_540_1650)" />
            <defs>
                <linearGradient id="paint0_linear_540_1650" x1="112.715" y1="-5.23546e-07" x2="0.176075" y2="81.9158" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#EAC64C" />
                    <stop offset="0.554786" stopColor="#C09325" />
                    <stop offset="1" stopColor="#AF7D14" />
                </linearGradient>
            </defs>
        </svg>
    );
}
